import cafe from './03_cafe.svg'
import restaurant from './04_restaurant.svg'
import transport from './05_transport.svg'
import school from './06_school.svg'
import exercise from './07_exercise.svg'
import park from './08_park.svg'
import liver from './09_liver.svg'
import sea from './10_sea.svg'
import library from './11_library.svg'
import culture from './12_culture.svg'
import leisure from './13_leisure.svg'
import etc from './14_etc.svg'

// interface CategoryIconMap {
//     [key: number]: string;
// }

// export const categoryIcons: CategoryIconMap = {
//     1: cafe,
//     2: restaurant,
//     3: transport,
//     4: school,
//     5: exercise,
//     6: park,
//     7: liver,
//     8: sea,
//     9: library,
//     10: culture,
//     11: leisure,
//     12: etc
// };

export const categoryIcons = [cafe, restaurant, transport, school, exercise, park, liver, sea, library, culture, leisure, etc]